<template>
    <b-modal id="modal-ba-penolakan" v-model="show" title="Alasan Penolakan Permohonan" ok-title="Simpan"
        cancel-title="Batal" size="lg" header-bg-variant="light" footer-bg-variant="light" @ok="handleSave"
        @hidden="resetForm">
        <!-- Card Detail Informasi Permohonan -->
        <b-card bg-variant="light" class="border mb-4 shadow-sm">
            <b-row class="text-dark">
                <b-col md="6" class="mb-2 mb-md-0">
                    <small class="text-muted d-block font-weight-bold text-uppercase">Nomor Permohonan</small>
                    <span class="font-weight-bold text-primary">{{ rowData.nomor_permohonan || '-' }}</span>
                </b-col>
                <b-col md="6">
                    <small class="text-muted d-block font-weight-bold text-uppercase">Instansi Pemohon</small>
                    <span class="font-weight-bold">{{ rowData.tipe_pemohon == 'Swasta' || rowData.tipe_pemohon == 'Pemerintah' ? rowData.instansi_pemohon : rowData.nama_pemohon }}</span>
                </b-col>
            </b-row>
        </b-card>

        <!-- Form Alasan Penolakan -->
        <b-form @submit.stop.prevent="submitForm">
            <b-form-group label="Alasan Penolakan" label-for="alasan-penolakan"
                description="Masukkan alasan penolakan secara jelas dan rinci.">
                <ckeditor :editor="wygEditor" v-model="form.alasan_penolakan"
                    :class="{ 'is-invalid': errors.has('Alasan Penolakan') }" v-validate="'required'"></ckeditor>
                <!-- <b-form-textarea
          id="alasan-penolakan"
          v-model="form.alasan_penolakan"
          placeholder="Tuliskan alasan penolakan di sini..."
          rows="4"
          max-rows="8"
          v-validate="'required'"
          name="Alasan Penolakan"
          :class="{ 'is-invalid': errors.has('Alasan Penolakan') }"
        ></b-form-textarea> -->
                <span class="text-danger" v-if="errors.has('Alasan Penolakan')">
                    {{ errors.first("Alasan Penolakan") }}
                </span>
            </b-form-group>
        </b-form>
    </b-modal>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Swal from 'sweetalert2'

export default {
    name: 'ModalBAPenolakan',
    components: { ClassicEditor },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        rowData: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            wygEditor: ClassicEditor,
            form: {
                alasan_penolakan: '',
            },
        }
    },
    computed: {
        show: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            },
        },
    },
    watch: {
        rowData: {
            handler(val) {
                if (val && Object.keys(val).length > 0) {
                    this.form.alasan_penolakan = val.alasan_penolakan || ''
                }
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        handleSave(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.submitForm()
        },

        submitForm() {
            // Validasi kelengkapan inputan alasan penolakan
            if (!this.form.alasan_penolakan || !this.form.alasan_penolakan.trim()) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Peringatan',
                    text: 'Harap isi alasan penolakan terlebih dahulu.',
                })
                return
            }

            // Kirim event submit dengan payload alasan_penolakan
            this.$emit('submit', {
                id: this.rowData.id,
                alasan_penolakan: this.form.alasan_penolakan,
            })

            resetForm()
        },

        resetForm() {
            this.form = {
                alasan_penolakan: '',
            }
        },
    },
}
</script>